// Converts a string with "\n\n" into multiple paragraphs
export default function stringToParagraphs(text: string): React.ReactNode[] {
  return text?.split("\n\n")?.map((para, idx) => (
    <div key={idx}>
      <div>{para}</div>
    </div>
  ));
}
